import L from 'leaflet';

export const VenueLocationIcon = L.icon({
  iconUrl: require('../assets/dot_1.svg'),
  iconRetinaUrl: require('../assets/dot_1.svg'),
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [20, 15],
  className: 'leaflet-venue-icon'
});
